export default __webpack_public_path__ + "static/media/logo_without_background_2.34e30278.png";